import React from 'react'
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom'

import Home from './pages/Home/Home'
import Yoga from './pages/Yoga/Yoga'
import About from './pages/About/About'
import Tutorials from './pages/Tutorials/Tutorials'
import Chat from './pages/Chat/Chat'
import Diet from './pages/Diet/Diet'
import Navbar from './components/ui/Navbar'

import './App.css'

export default function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />}/>
          <Route path='/start' element={<Yoga />} />
          <Route path='/about' element={<About />} />
          <Route path='/tutorials' element={<Tutorials />} />
          <Route path='/chat' element={<Chat />} />
          <Route path='/diet' element={<Diet />} />
        </Routes>
      </div>
    </Router>
  )
}


